import React from "react";
import style from '../AboutMe/AboutMe.module.css';

const AboutMe = () => {
    return (
        <div className={style.containerAboutMe}>
            <section>
                <h2 className={style.aboutTitle}>Sobre mí</h2>
                <div className={style.aboutContent}>
                    <div className={style.aboutText}>
                        <p>Mi nombre es Nahuel Rodriguez. Me gradué este año como Full Stack Web Developer en el Bootcamp de la plataforma Henry, y también obtuve el título de Front-End Developer en el curso de ALURA LATAM en 2022.</p>
                        <p>Durante mi formación, he tenido la oportunidad de participar tanto en proyectos individuales como en equipo. Desarrollé un proyecto para la plataforma “Henry” y también colaboré en una pasantía para la empresa “Somos Edison”. Estas oportunidades me permitieron mejorar mis habilidades de trabajo en equipo, afrontar desafíos en un entorno real de desarrollo y aplicar mis conocimientos en un contexto empresarial. Si estás buscando un colaborador o un nuevo recluta, ¡no dudes en contactarme!</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AboutMe;
